import { IIndicatorData } from "./iindicator-data-strategy";
import { IndicatorData } from "./indicator-data";

export class TopTenPractitionerIndicatorData implements IIndicatorData {
  private readonly name: string = "TopTenPractitioner";

  constructor(private readonly items: IndicatorData[]) {}

  public getName(): string {
    return this.name;
  }

  public getTotal(): string {
    return this.items[0].getValue() as string;
  }

  public getItems() {
    return this.items.slice(1).map((item) => {
      const practitionerNameIdicatorData = item.getValue()[0] as IndicatorData;
      const practitionerName = practitionerNameIdicatorData.getValue();

      const practitionerStateIdicatorData = item.getValue()[1] as IndicatorData;
      const practitionerState = practitionerStateIdicatorData.getValue();

      const practitionerQuantityIdicatorData = item.getValue()[2] as IndicatorData;
      const practitionerQuantity = practitionerQuantityIdicatorData.getValue();

      const practitionerPercentageIdicatorData = item.getValue()[3] as IndicatorData;
      const practitionerPercentage = practitionerPercentageIdicatorData.getValue();

      return {
        practitionerRegistration: item.getKey(),
        practitionerName,
        practitionerState,
        practitionerQuantity,
        practitionerPercentage,
      };
    });
  }
}
